/**
 * Where the venue page was scrolled to when the user tapped a row through to a match result.
 *
 * Ionic keeps the page it pushed from mounted, and with it the scroll position — but only while
 * the outlet still holds that view, and the venue page rebuilds itself from cache when it does
 * not, landing the user back at the top of a page they were halfway down. One slot is enough:
 * the user can only leave one venue page at a time, and the depth means nothing once it has been
 * handed back.
 */
let left: { key: string; top: number } | null = null;

/** Remember the depth to come back to. A page at the top has nothing worth restoring. */
export function rememberVenueScroll(key: string, top: number): void {
    left = top > 0 ? { key, top } : null;
}

/** The depth to restore for this page, or 0 when the user did not leave from here. */
export function venueScrollFor(key: string): number {
    return left && left.key === key ? left.top : 0;
}

export function forgetVenueScroll(): void {
    left = null;
}
